import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wallet-transaction',
  templateUrl: './wallet-transaction.component.html',
  styleUrls: ['./wallet-transaction.component.scss']
})
export class WalletTransactionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
